// extracted by mini-css-extract-plugin
export default {"menuBlock":"rG-z","title":"sG-z","nav":"tG-z","flexCell":"uG-z","facetLink":"vG-z"};